import { render, staticRenderFns } from "./partydati.vue?vue&type=template&id=e22bb7f0&scoped=true&"
import script from "./partydati.vue?vue&type=script&lang=js&"
export * from "./partydati.vue?vue&type=script&lang=js&"
import style0 from "./partydati.vue?vue&type=style&index=0&id=e22bb7f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e22bb7f0",
  null
  
)

export default component.exports